module.exports = __webpack_public_path__ + "js/0.6eccb608.worker.js"